/**
 * Registers Forms shadow CSS on window.formStyles.
 * Uses window.__SAFESAND_FORM_TOKENS__ and the CSS URL on this script's data-css.
 */
(function () {
  window.formStyles = window.formStyles || new Map();

  function buildHostTokensCss() {
    var liquidTokens = window.__SAFESAND_FORM_TOKENS__;
    if (!liquidTokens || typeof liquidTokens !== 'object') return '';

    var decls = [];
    var name;
    for (name in liquidTokens) {
      if (!Object.prototype.hasOwnProperty.call(liquidTokens, name)) continue;
      if (liquidTokens[name] === '' || liquidTokens[name] == null) continue;
      decls.push('  ' + name + ': ' + String(liquidTokens[name]).trim() + ';');
    }
    if (!decls.length) return '';

    return ':host {\n' + decls.join('\n') + '\n}\n\n';
  }

  function setStyles(cssText) {
    window.formStyles.set('safesand-forms', buildHostTokensCss() + (cssText || ''));
  }

  var script = document.currentScript;
  var cssUrl = script && script.getAttribute('data-css');

  if (!cssUrl) {
    setStyles('');
    return;
  }

  try {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', cssUrl, false);
    xhr.send(null);
    if (xhr.status >= 200 && xhr.status < 400 && xhr.responseText) {
      setStyles(xhr.responseText);
      return;
    }
  } catch (e) {}

  setStyles('');
})();
